<template>
  <div
    v-bind:style="showModalForm ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-info" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Editar</h5>
          <button
            @click="close"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
          <div class="modal-body">
            <!-- <img :src="modal_km.image" width="400" /> -->
            <form-fuel :refueling_id="refueling_id" @update="update"/>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormFuel from './Form'
export default {
  name: "ModalForm",
  components: { FormFuel },
  props: ["showModalForm", "refueling_id"],
  methods: {
    close() {
      this.$emit("close");
    },
    update(refueling){
      this.$emit('update', refueling)
    }
  }
};
</script>